import {get, post} from '@/utils/request.js'
const loginApi = {
  userLogin: function (params) {
    return post('/merchant/login.do', {
      mail: params.mail,
      passwd: params.passwd
    })
  },
  logout: function () {
    return get('merchant/logout.do', {
    })
  }
}

export default loginApi



// WEBPACK FOOTER //
// ./src/api/login.js